import { useEffect } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Minus, Plus } from 'assets/icons';
import { useStore } from 'stores';
import InputWithButton from 'components/InputWithButton';
import Stock from 'components/Stock';
import { getDynamicProfitOrderby, getUserAiSMProfit } from 'api/calculate';
import StockFooter from './StockFooter';
import SymbolSelect from './SymbolSelect';
import StrategySelect from './StrategySelect';
import LongShortSelect from './LongShortSelect';
import Chart from './Chart';
import TagList from './TagList';

import { DAY_RANGE } from '__mocks__/AllStock';

export default function AllStock() {
  const { t } = useTranslation();
  const isLogin = useStore((state) => state.isLogin);
  const currentStock = useStore((state) => state.currentStock); // 股票代號
  const currentLongShort = useStore((state) => state.currentLongShort); // 長短
  const currentEmail = useStore((state) => state.currentEmail); // 登入的 email
  const setDynamicProfitOrderby = useStore((state) => state.setDynamicProfitOrderby); // 應該是 chart 的資料
  const setUserAiSMProfit = useStore((state) => state.setUserAiSMProfit); // chart 的 開盤價 收盤價那些
  const currentStrategy = useStore((state) => state.currentStrategy);
  const currentDayRange = useStore((state) => state.dayRange);
  const setDayRange = useStore((state) => state.setDayRange);
  const increaseDayRange = useStore((state) => state.increaseDayRange);
  const minusDayRange = useStore((state) => state.minusDayRange);
  const strategyList = useStore((state) => state.strategyList);
  const setCurrentStrategy = useStore((state) => state.setCurrentStrategy);

  useEffect(() => {
    async function fetchUserAiSMProfit() {
      if (!currentStock || !currentStrategy) {
        return;
      }
      setUserAiSMProfit([]);
      const res = await getUserAiSMProfit(
        currentEmail,
        currentStock.marketId,
        currentStrategy.StrategyProfileId,
        currentLongShort
      );
      setUserAiSMProfit(res);
    }

    fetchUserAiSMProfit();
  }, [currentEmail, currentLongShort, currentStock, currentStrategy, setUserAiSMProfit]);

  useEffect(() => {
    async function fetchDynamicProfitOrderby() {
      if (!currentStock) {
        return;
      }
      setDynamicProfitOrderby([]);
      const res = await getDynamicProfitOrderby(
        currentEmail,
        currentStock.marketId,
        currentLongShort
      );
      setDynamicProfitOrderby(res);
      setCurrentStrategy(
        strategyList.find(({ StrategyProfileId }) => StrategyProfileId === res[0].strategyProfileId)
      );
    }

    fetchDynamicProfitOrderby();
  }, [
    currentEmail,
    currentLongShort,
    currentStock,
    setCurrentStrategy,
    setDynamicProfitOrderby,
    strategyList,
  ]);

  return (
    <div>
      <div className="px-8">
        <InputWithButton type="search" placeholder={t('AllStock.pleaseEnterNumberOrName')} />
        <SymbolSelect />
        <div className="flex w-full mb-6">
          <StrategySelect />
          <LongShortSelect />
        </div>
      </div>
      <Stock />
      <div>
        <div className="bg-gray-dark p-2">
          <div className="flex items-center space-x-2.5 p-4">
            <div className="flex-1 text-white font-semibold text-2xl">
              {t('AllStock.linearTrend')}
            </div>
            <button className="text-3xl text-blue border border-blue rounded-lg p-2">
              <Plus onClick={increaseDayRange} />
            </button>
            <button className="text-3xl text-blue border border-blue rounded-lg p-2">
              <Minus onClick={minusDayRange} />
            </button>
          </div>

          <div className="bg-sky rounded-lg mx-2 mb-2 flex">
            {DAY_RANGE.map((range) => {
              const isActive = range.value === currentDayRange;
              return (
                <button
                  key={`day_range_${range.key}`}
                  className={classNames('rounded-lg flex-1 p-2', {
                    'text-blue': !isActive,
                    'bg-blue font-bold text-white': isActive,
                  })}
                  onClick={() => setDayRange(range.value)}
                >
                  {range.key}
                </button>
              );
            })}
          </div>
          <Chart />
        </div>
      </div>
      {/* 自選策略清單 */}
      {isLogin && <TagList />}

      <div className="m-4">
        <p className="text-xs text-gray">{t('AllStock.desc')}</p>
      </div>

      {!isLogin && <StockFooter />}
    </div>
  );
}
